import { type ChatbotMessage, MessageRole } from '../types/messageTypes'

export const getHasHumanInteraction = (chatHistoryMessages: ChatbotMessage[]) =>
	chatHistoryMessages.some((message) => message.role === MessageRole.Human)
